import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { CruiseCardCompareCheckboxBase, CruiseCardCompareCheckboxButton } from './CruiseCardCompareCheckbox.styles';
import { CruiseCardCompareCheckboxProps } from './CruiseCardCompareCheckbox.types';
import { utagCompareCheckbox } from 'contexts/AnalyticsContext/functions';

function CruiseCardCompareCheckbox({ cruiseSrc, index, count, className }: Readonly<CruiseCardCompareCheckboxProps>) {
  const [checked, setChecked] = useState(false);
  const { globalization, locale, brand }: any = useContext(CruiseSearchContext);
  const {
    addCruiseToComparing,
    removeCruiseFromComparing,
    cruisesComparing,
    remainingCountForSelection,
  }: any = useContext(CruiseSelectionContext);
  const { compareDictionary } = globalization?.dictionaries || {};
  const { actionCompare } = compareDictionary;

  const handleCheckboxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;

    if (checked) {
      addCruiseToComparing(cruiseSrc);
    } else {
      removeCruiseFromComparing(cruiseSrc);
    }

    setChecked(checked);
    utagCompareCheckbox(cruiseSrc, index, count, checked, locale, brand);
  }, [cruiseSrc]);

  useEffect(() => {
    setChecked(Boolean(cruisesComparing.find(cruise => cruise.id === cruiseSrc.id)));
  }, [cruisesComparing]);

  return (
    <CruiseCardCompareCheckboxBase
      control={
        <CruiseCardCompareCheckboxButton
          checked={checked}
          onChange={handleCheckboxChange}
        />
      }
      label={actionCompare}
      disabled={!checked && remainingCountForSelection === 0}
      onClick={(event) => event.stopPropagation()}
      className={className}
    />
  );
}

export default CruiseCardCompareCheckbox;